import React from 'react';
import PropTypes from 'prop-types';

// Shared
import { H4, DivWithShadowAlternate } from '@styled';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import LoadingArea from '@molecules/LoadingArea';
import Search from '../../searches/Search';
import SearchResults from '../../searches/Search/SearchResults';
import MemberCardRedesign from '@molecules/MemberCardRedesign/MemberCardRedesign';
import MemberListItemRedesign from '@molecules/MemberListItemRedesign/MemberListItemRedesign';
import RefinementsCompanyProfileAffiliatedMembers from './RefinementsCompanyProfileAffiliatedMembers';

// Functionality
import { SAVED_CONTACTS_RECORD_ID_QUERY } from '@general/graphql/contact.graph';
import { mapSearchMemberToProps } from '@general/transforms/member.transform';
import useCompanyFull from '@hooks/useCompanyFull';
import useViewer from '@hooks/useViewer';
import useCompanyProfileAffiliatedMembersFilterString from './hooks/useCompanyProfileAffiliatedMembersFilterString';

const CompanyProfileAffiliatedMembers = ({ graphID }) => {
    const { data: companyData, loading } = useCompanyFull(graphID);
    const { viewer, loading: loadingViewer } = useViewer();
    const affiliatedMembersFilterString = useCompanyProfileAffiliatedMembersFilterString({
        company: companyData,
        viewer,
    });

    if (!companyData || !viewer) {
        return null;
    }

    if (loading || loadingViewer) {
        return <LoadingArea />;
    }

    return (
        <div className="col-lg-12 mt-4">
            <H4 className="mb-1.5rem">Affiliated Members</H4>
            <DivWithShadowAlternate className="p-4" style={{ width: '100%' }}>
                <SearchModeContext.Provider value={{ showFilters: false }}>
                    <Search
                        filters={affiliatedMembersFilterString}
                        index="members"
                        defaultViewType="card"
                        displayPagingToolbar
                        displaySearchBox
                        displaySearchOptions
                        hitsPerPage={16}
                        maxWidth="auto"
                        refinementComponent={RefinementsCompanyProfileAffiliatedMembers}
                    >
                        <SearchResults
                            cardComponent={props => <MemberCardRedesign graphID={graphID} {...props} />}
                            listItemComponent={props => <MemberListItemRedesign graphID={graphID} {...props} />}
                            index="members"
                            NoResultsText={() => <>There are no members affiliated with this company.</>}
                            query={SAVED_CONTACTS_RECORD_ID_QUERY}
                            transformFunc={mapSearchMemberToProps}
                            typePlural="contacts"
                            resultsPerRow={2}
                        />
                    </Search>
                </SearchModeContext.Provider>
            </DivWithShadowAlternate>
        </div>
    );
};

CompanyProfileAffiliatedMembers.propTypes = {
    graphID: PropTypes.string,
};

export default CompanyProfileAffiliatedMembers;
